import { NgModule } from '@angular/core';
import { ArabicNumberPipe } from './arabic-number.pipe';
import { ContentCoreDataPipe } from './content-core-data.pipe';
import { ContentExtendedDataPipe } from './content-extended-data.pipe';
import { CurrentLocalePipe } from './current-locale.pipe';
import { FormatAltTagPipe } from './format-alt-tag.pipe';
import { PlayButtonTextPipe } from './play-button-text.pipe';
import { PrettyTransformPipe } from './pretty-transform.pipe';
import { ReplacePriceAndCurrencyPipe } from './replace-price-and-currency.pipe';
import { SecondsToHourPipe } from './seconds-to-hour.pipe';
import { SecondsToMinutesPipe } from './seconds-to-minutes.pipe';
import { ShallowPreviewOverlayVmPipe } from './shallow-preview-overlay-vm.pipe';
import { TrackByPropertyPipe } from './track-by-property.pipe';
import { TranslateCutPipe } from './translate-cut.pipe';
import { WatchFreeTrialPipe } from './watch-free-trial.pipe';

const PIPES = [
  FormatAltTagPipe,
  SecondsToHourPipe,
  SecondsToMinutesPipe,
  PlayButtonTextPipe,
  ArabicNumberPipe,
  TrackByPropertyPipe,
  ReplacePriceAndCurrencyPipe,
  TranslateCutPipe,
  WatchFreeTrialPipe,
  PrettyTransformPipe,
  ContentCoreDataPipe,
  ContentExtendedDataPipe,
  CurrentLocalePipe,
  ShallowPreviewOverlayVmPipe,
];

@NgModule({
  declarations: PIPES,
  exports: PIPES,
  providers: PIPES,
})
export class SharedPipesModule {}

export * from './arabic-number.pipe';
export * from './format-alt-tag.pipe';
export * from './play-button-text.pipe';
export * from './replace-price-and-currency.pipe';
export * from './seconds-to-hour.pipe';
export * from './seconds-to-minutes.pipe';
export * from './track-by-property.pipe';
export * from './translate-cut.pipe';
export * from './watch-free-trial.pipe';
